@if (selectedGlobalAction == "print") {
  <div class="scheduler-container" id="section-to-print">
    <h2 class="fs-6 mb-2 text-center">
      {{ selectedJobType?.name }} Shifts:
      <span
        >{{ weekDays[0] | date: "d MMM y" }} -
        {{ weekDays[weekDays?.length - 1] | date: "d MMM y" }}</span
      >
    </h2>
    <div class="roster-print">
      <table class="table table-sm table-bordered table-fixed">
        <thead>
          <th class="table-secondary"></th>
          @for (day of weekDays; track day) {
            <th class="table-secondary">
              <div
                class="fw-normal"
                [class.fw-bold]="currentDay == (day | date: 'yyyy-MM-dd')"
              >
                <div class="d-flex gap-1 mx-auto justify-content-center">
                  <div class="">
                    {{ day | date: "EEEE" }}
                  </div>
                  <div class="">{{ day | date: "d MMM" }}</div>
                </div>
              </div>
            </th>
          }
        </thead>
        <tbody>
          @for (
            row of shiftDataGroupBy == "person"
              ? isAdminUser || isDispatcherUser
                ? (userListData
                  | misc
                    : "getScheduleRowHeaders"
                    : !!filteredRosteredList?.length
                    : shiftDataGroupBy
                    : userListFilterId
                    : shiftFilterData?.selectedUsers
                    : "print")
                : [currentUserData]
              : (siteListData
                | misc
                  : "getScheduleRowHeaders"
                  : !!filteredRosteredList?.length
                  : shiftDataGroupBy
                  : userListFilterId
                  : shiftFilterData?.selectedSites
                  : "print");
            track row?.id
          ) {
            <tr class="avoid-page-break">
              <td>
                <div class="d-flex justify-content-between gap-1 mb-2">
                  <span>
                    <div [class.text-danger]="!row?.id">
                      @if (
                        selectedClient?.id == 1 &&
                        shiftDataGroupBy != "person" &&
                        row?.company?.company_name
                      ) {
                        <div>
                          {{ row?.company?.company_name }}
                        </div>
                      }
                      {{
                        shiftDataGroupBy == "person"
                          ? row?.full_name
                          : row?.company_name
                      }}
                    </div>
                  </span>
                  @if (shiftDataGroupBy == "person") {
                    @let hoursRostered =
                      shiftStatsBySite?.[row?.id]?.hours ||
                      shiftStatsByAssignee?.[row?.id]?.hours;

                    @if (hoursRostered) {
                      <div
                        class="d-flex align-items-center gap-1 mono-font"
                        id="hours-rostered"
                      >
                        {{ hoursRostered | misc: "getHoursFromMilliSeconds" }}
                      </div>
                    }
                  }
                </div>
              </td>
              @for (day of weekDays; track day) {
                <td>
                  @if (row?.id == -1) {
                    <div>
                      @let convertedDate = (day | date: "yyyy-MM-dd") || 0;
                      @let hoursRosteredByDate =
                        shiftStatsByDate?.[convertedDate]?.hours;

                      @if (hoursRosteredByDate) {
                        <div
                          class="d-flex align-items-center gap-1 mono-font justify-content-center"
                          id="hours-rostered-by-day"
                        >
                          {{
                            hoursRosteredByDate
                              | misc: "getHoursFromMilliSeconds"
                          }}
                        </div>
                      }
                    </div>
                  } @else {
                    @let cellKey = row?.id | misc: "getScheduleCellKey" : day;
                    <!-- @let cellKey = getScheduleCellKey(row.id, day) row?.id | misc:'getScheduleCellKey' :day; -->
                    @let colItems = rosterGridMap?.[cellKey] || [];
                    @let pastShift = day | misc: "isPastScheduleCheck";

                    @let isUserOnLeave = userLeaveData?.[cellKey];

                    <div
                      (click)="selectedGlobalAction = ''; selectedShift = null"
                    >
                      @if (isUserOnLeave?.length) {
                        <ng-template
                          *ngTemplateOutlet="
                            leaveInfoTemplate;
                            context: { isUserOnLeave }
                          "
                        ></ng-template>
                      }
                      @if (colItems.length) {
                        <div class="d-flex flex-column gap-1 mb-1">
                          @for (item of colItems; track item.id) {
                            @let conflictShift =
                              (conflictData
                                | misc: "rosterShiftDictEventDateData" : day)?.[
                                item?.assignee_id
                              ]?.jobs;

                            <div
                              class="rostered-item text-dark small-font"
                              [ngClass]="
                                [2, 3].includes(item?.status_dict?.identity)
                                  ? 'border border-danger'
                                  : pastShift
                                    ? 'border border-success'
                                    : item?.draftedItem
                                      ? 'border border-warning'
                                      : !item?.assignee_id
                                        ? 'border border-danger'
                                        : 'border border-success'
                              "
                            >
                              <ng-template
                                *ngTemplateOutlet="
                                  shiftDetailTemplate;
                                  context: { item, conflictShift, day }
                                "
                              ></ng-template>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
} @else {
  <div
    class="d-flex justify-content-between px-1 pb-2 flex-column flex-lg-row gap-1"
  >
    <div
      class="d-flex flex-wrap gap-1 gap-lg-2 flex-lg-row flex-column align-items-lg-center"
    >
      @if (
        filteredRosteredDataStat?.count &&
        (selectedClient?.id || [6, 4].includes(selectedJobType?.type_identity))
      ) {
        <div
          class="d-flex flex-row gap-2 align-items-lg-center justify-content-around small px-1"
        >
          <div class="pe-3">
            <span>Shifts: </span>
            <span class="fw-semibold">
              @if (
                filteredRosteredDataStat?.assigned <
                filteredRosteredDataStat?.count
              ) {
                {{ filteredRosteredDataStat?.assigned }} /
                {{ filteredRosteredDataStat?.count }}
              } @else {
                {{ filteredRosteredDataStat?.count }}
              }
            </span>
          </div>
        </div>
      }

      @let hasDraftedChanges =
        dataBackupDict.idsToBeDeleted?.size ||
        dataBackupDict.draftedChanges?.length;
      <!--job type selection-->
      <div>
        <select
          class="form-select form-select-lg"
          role="button"
          [ngModel]="selectedJobType?.id"
          (change)="onSelectJobType($event)"
        >
          @for (jType of availableJobTypes; track $index) {
            <option [value]="jType.id">
              {{ jType?.name }}
            </option>
          }
        </select>
      </div>

      <!--client selection-->
      @if (![6, 4].includes(selectedJobType?.type_identity)) {
        <div class="d-flex align-items-center fs-6">
          @if (selectedClient?.id) {
            <dl class="px-2 m-0">
              <dd class="d-flex gap-2 align-items-center py-2">
                <div>
                  {{ selectedClient?.company_name }}
                </div>
                <span (click)="editField('client')" class="edit-button"></span>
              </dd>
            </dl>
          } @else {
            <gtapp-auto-complete
              class="w-100"
              [data]="clientDropDownList"
              placeHolder="Select Client"
              searchKeyword="company_name"
              [itemTemplate]="clientLookupTemplate"
              [addInitialKey]="true"
              (inputChanged)="onClientSearch($event)"
              (selected)="onClientSelect($event)"
              [enableCloseOption]="true"
              inputId="scheduleClientLookupFieldId"
              (fieldCleared)="editField('client')"
              [additionalConfig]="{ containerHeightMax: 'calc(100vh - 170px)' }"
            >
            </gtapp-auto-complete>
            <ng-template #clientLookupTemplate let-item>
              @if (item?.key === 0) {
                <div class="fw-semibold card-text-color">All Shifts</div>
              } @else {
                <div>
                  {{ item?.company_name }}
                </div>
              }
            </ng-template>
          }
        </div>
        @if (selectedClient?.id && largeView) {
          <div class="d-flex btn-group">
            <button
              title="Site"
              class="btn btn-sm"
              [ngClass]="
                shiftDataGroupBy === 'site'
                  ? 'btn-primary'
                  : 'btn-outline-primary bg-white'
              "
              (click)="changeShiftGroupBy('site')"
            >
              <!-- <i class="fa-solid fa-location-dot"></i> -->
              Sites
            </button>

            <button
              title="Person"
              class="btn btn-sm"
              [ngClass]="
                shiftDataGroupBy === 'person'
                  ? 'btn-primary'
                  : 'btn-outline-primary bg-white'
              "
              (click)="changeShiftGroupBy('person')"
            >
              <!-- <i class="fa-regular fa-circle-user"></i> -->
              Staff
            </button>
          </div>
        }
      }
      @if (
        largeView &&
        (filteredRosteredList?.length > 1 ||
          shiftFilterData?.selectedUsers?.length ||
          shiftFilterData?.selectedSites?.length)
      ) {
        <div>
          <button
            class="btn btn-sm"
            [ngClass]="
              shiftFilterData?.selectedUsers?.length ||
              shiftFilterData?.selectedSites?.length
                ? 'btn-danger'
                : 'btn-secondary'
            "
            (click)="openTemplate('filterShifts', filterShiftsTemplate)"
          >
            {{
              shiftFilterData?.selectedUsers?.length ||
              shiftFilterData?.selectedSites?.length
                ? "Filter Applied"
                : "Filter Data"
            }}
          </button>
        </div>
        @if (filteredRosteredList?.length) {
          <div data-bs-toggle="tooltip" data-bs-placement="top" title="Print">
            <button
              class="btn btn-sm btn-secondary"
              (click)="openPrintDialog()"
            >
              <i class="fa-solid fa-print"></i>
            </button>
          </div>
        }
      }
      <!--date selector-->
      <div id="date-selection" class="d-flex gap-2 flex-wrap">
        @if (selectedSearchDate) {
          <div class="flex-grow-1">
            @if (largeView) {
              <div
                class="position-relative bg-white border text-dark text-center rounded d-flex align-items-center p-2 form-control justify-content-center fw-semibold"
                role="button"
              >
                <span
                  >{{ weekDays[0] | customDate: "d MMM y" }} -
                  {{
                    weekDays[weekDays?.length - 1] | customDate: "d MMM y"
                  }}</span
                >
                <span><i class="fa-solid fa-calendar ms-1"></i></span>

                <input
                  class="hidden-calendar-lookup"
                  type="date"
                  [(ngModel)]="selectedSearchDate"
                  (change)="onDateSelect('search', '=')"
                />
              </div>
            } @else {
              <div
                class="position-relative bg-white border text-dark text-center rounded d-flex align-items-center p-2 form-control justify-content-center fw-semibold"
                role="button"
              >
                <span>
                  {{ selectedSearchDate | date: "EEEE" }}
                  {{ selectedSearchDate | customDate: "d MMM y" }}
                </span>
                <span><i class="fa-solid fa-calendar ms-1"></i></span>

                <input
                  class="hidden-calendar-lookup"
                  type="date"
                  [(ngModel)]="selectedSearchDate"
                  (change)="onDateSelect('search', '=')"
                />
              </div>
            }
          </div>
        }

        @if (largeView) {
          <div
            (click)="onDateSelect('week', '-')"
            class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button flex-grow-1 d-flex justify-content-center p-2"
            role="button"
          >
            <i class="fas fa-angle-left"></i>
          </div>

          <div
            (click)="onDateSelect('week', '+')"
            class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button flex-grow-1 d-flex justify-content-center p-2"
          >
            <i class="fas fa-angle-right"></i>
          </div>
        }
        @if (!isCurrentWeek && largeView) {
          <div
            (click)="onDateSelect(largeView ? 'week' : 'day', '=')"
            class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button small fw-medium p-2"
            role="button"
          >
            Today
          </div>
        }
      </div>

      @if (
        (selectedClient?.id ||
          [6, 4].includes(selectedJobType?.type_identity)) &&
        (isAdminUser || isDispatcherUser)
      ) {
        <div class="d-flex flex-wrap gap-2 align-items-center">
          @if (
            !selectedGlobalAction &&
            selectedShift?.id &&
            !selectedShift?.draftedItem
          ) {
            <!-- selected shift contextual action-btns-->
            <button
              class="btn py-2 btn-primary px-4"
              (click)="onRedirectShift(selectedShift)"
            >
              Full Details
            </button>
          }
          @if (
            selectedShiftBackup?.start_time &&
            ![2, 3].includes(selectedShift?.status_dict?.identity)
          ) {
            <div class="d-flex gap-1 align-items-center">
              @if (
                selectedShiftBackup?.assignee_id ==
                  selectedShift?.assignee_id || selectedShift?.draftedItem
              ) {
                <div>
                  <input
                    class="form-control"
                    placeholder="Start"
                    type="time"
                    [(ngModel)]="selectedShift.start_time"
                    (ngModelChange)="updateShiftInDraftedChanges()"
                  />
                </div>
                <div>-</div>
                <div>
                  <input
                    class="form-control"
                    placeholder="End"
                    type="time"
                    [(ngModel)]="selectedShift.end_time"
                    (ngModelChange)="updateShiftInDraftedChanges()"
                  />
                </div>
                <div class="d-flex flex-column px-2">
                  <div>
                    <dt>Duration</dt>
                  </div>
                  <div class="fw-medium small">
                    {{
                      getTimeDifference(selectedShift)
                        | misc: "getHoursFromMilliSeconds"
                    }}
                    Hours
                  </div>
                </div>
              }
              @if (
                (selectedShiftBackup?.start_time == selectedShift?.start_time &&
                  selectedShiftBackup?.end_time == selectedShift?.end_time) ||
                selectedShift?.draftedItem
              ) {
                <div>
                  <!-- @if (selectedShift?.assignee_id) {
                      <dl class="px-2 m-0">
                        <dd class="d-flex gap-2 align-items-center py-2">
                          <div>
                            {{ selectedShift?.assignee_name }}
                          </div>
                          <span
                            (click)="selectedShift.assignee_id = ''"
                            class="edit-button"
                          ></span>
                        </dd>
                      </dl>
                    } @else { -->
                  <gtapp-auto-complete
                    [data]="userLookupListData"
                    placeHolder="Assigned to"
                    searchKeyword="full_name"
                    [initialValue]="userSearchString"
                    [itemTemplate]="userTemplate"
                    [addInitialKey]="selectedShift?.assignee_id"
                    inputId="scheduleUserLookupFieldId"
                    (inputChanged)="onUserLookup($event)"
                    (selected)="onEditUserOnSelectedShift($event)"
                  >
                  </gtapp-auto-complete>
                  <ng-template #userTemplate let-item>
                    @if (item?.key == 0) {
                      <div class="text-danger">Remove Assignee</div>
                    } @else {
                      <div
                        class="d-flex gap-2 flex-wrap justify-content-between align-items-start"
                      >
                        <div class="d-flex gap-2 flex-wrap align-items-start">
                          <span>
                            {{ item?.full_name }}
                          </span>
                          @if (item?.access_status === 2) {
                            <div
                              class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                            >
                              Casual
                            </div>
                          }
                        </div>
                        <div class="text-secondary small-font">
                          @if (shiftStatsByAssignee?.[item?.id]?.hours) {
                            <div>
                              Hours:
                              {{
                                shiftStatsByAssignee?.[item?.id]?.hours
                                  | misc: "getHoursFromMilliSeconds"
                              }}
                            </div>
                          }
                          @if (shiftStatsByAssignee?.[item?.id]?.shifts) {
                            <div>
                              Shifts:
                              {{ shiftStatsByAssignee?.[item?.id]?.shifts }}
                            </div>
                          }
                        </div>
                      </div>

                      @if (item?.subcontractors?.length) {
                        <div class="small text-secondary">
                          🟧Subcontractor:
                          <span class="subcontractor-name">{{
                            item?.subcontractors
                          }}</span>
                        </div>
                      }
                    }
                  </ng-template>
                </div>
              }
            </div>

            <!-- @if (
              selectedShiftBackup?.start_time != selectedShift?.start_time ||
              selectedShiftBackup?.end_time != selectedShift?.end_time ||
              selectedShiftBackup?.assignee_id != selectedShift?.assignee_id
            ) {
              1232
              <div class="d-flex gap-2 h-100 w-100 pt-2">
                <button
                  class="h-100 btn py-2 btn-outline-danger"
                  (click)="onShiftReset()"
                >
                  Discard Changes
                </button>

                <button
                  class="h-100 btn py-2 btn-success"
                  (click)="onUpdateShift()"
                >
                  Save Changes
                </button>
              </div>
            } -->
          }
          @let hasShiftAltered =
            selectedShiftBackup?.start_time &&
            (selectedShiftBackup?.start_time != selectedShift?.start_time ||
              selectedShiftBackup?.end_time != selectedShift?.end_time ||
              selectedShiftBackup?.assignee_id != selectedShift?.assignee_id);
          @if ((hasDraftedChanges || hasShiftAltered) && largeView) {
            <div class="d-flex gap-2 h-100">
              <button
                class="h-100 btn py-2 btn-outline-danger flex-grow-1"
                (click)="onResetChanges(); deselectShift()"
              >
                Discard Changes
              </button>
              <button
                class="h-100 btn py-2 btn-success flex-grow-1"
                (click)="onSaveChanges(); onUpdateShift()"
              >
                Save Changes
              </button>
            </div>
          }
        </div>
      }
    </div>

    <div
      class="d-flex gap-1 gap-lg-3 flex-column flex-column-reverse flex-lg-row"
    >
      @if (fetchingData) {
        <div
          class="justify-content-end d-flex gap-1 small-font align-items-center"
        >
          <div>Fetching Data</div>
          <div
            class="spinner-border text-dark spinner-border-sm"
            role="status"
          ></div>
        </div>
      }
      @if (
        !selectedGlobalAction &&
        !selectedShift?.id &&
        !hasDraftedChanges &&
        (isAdminUser || isDispatcherUser) &&
        (selectedClient?.id || [6, 4].includes(selectedJobType?.type_identity))
      ) {
        <div class="d-flex flex-wrap gap-1 justify-content-end">
          <div class="d-flex gap-1">
            @if (!isPastWeek) {
              <button
                class="btn btn-sm btn-primary"
                (click)="
                  !largeView ||
                  (selectedClient?.id == 1 &&
                    !siteListData?.length &&
                    shiftDataGroupBy == 'site')
                    ? onModifyShift(modifyShiftTemplate, {}, selectedSearchDate)
                    : (selectedGlobalAction = 'add')
                "
              >
                Add
                @if (largeView) {
                  Shift
                }
              </button>
            }

            @if (filteredRosteredList?.length) {
              <button
                class="btn btn-sm btn-primary"
                (click)="selectedGlobalAction = 'duplicate'"
              >
                Copy
                @if (largeView) {
                  Shift
                }
              </button>
            }
            @if (!isPastWeek && !largeView && filteredRosteredList?.length) {
              <button
                class="btn btn-sm btn-danger"
                (click)="selectedGlobalAction = 'delete'"
              >
                Delete
                @if (largeView) {
                  Shift
                }
              </button>
            }
          </div>

          @if (filteredRosteredList?.length && !isPastWeek && largeView) {
            @if (filteredRosteredDataStat?.shiftsToClear) {
              <button
                class="btn btn-sm btn-danger"
                (click)="onClearAllShifts()"
              >
                Clear Shifts
              </button>
            }
            <button
              class="btn btn-sm btn-secondary"
              (click)="copyShiftsToNextWeek(copyConfirmTemplate)"
            >
              Copy Week
            </button>
          }
          @if (shiftsToPublishListFiltered?.length && !isPastWeek) {
            <button
              id="publishShiftBtn"
              class="btn btn-sm btn-success"
              (click)="
                openTemplate('publishShifts', sendShiftNotificationTemplate)
              "
            >
              Publish Shifts
            </button>
          }
        </div>
      }
      @if (selectedGlobalAction == "add" && largeView && !isPastWeek) {
        <div
          class="flex-grow-1 d-flex align-items-center justify-content-center"
          (click)="onModifyShift(modifyShiftTemplate, {}, selectedSearchDate)"
        >
          <button
            class="btn btn-sm btn-outline-primary px-lg-4 h-100 w-100 py-lg-0"
          >
            Manual Add
          </button>
        </div>
      }

      @if (selectedShift?.id || selectedGlobalAction) {
        <div
          class="d-flex flex-wrap gap-2 align-items-center justify-content-end"
        >
          <button
            class="btn py-2 btn-danger px-4"
            (click)="selectedGlobalAction = ''; deselectShift()"
          >
            Cancel
          </button>
        </div>
      }
    </div>
  </div>

  @if (largeView) {
    <div class="scheduler-container">
      <div class="grid-scroll-wrapper">
        <div class="scheduler-grid" cdkDropListGroup>
          <div class="grid-cell text-center grid-header-cell">
            <div class="p-1">
              Tags
              <select
                class="form-select form-select-sm"
                role="button"
                [ngModel]="userListFilterId"
                (change)="onUserListFilter($event)"
              >
                <option [value]="''">Show All Users</option>
                @for (jType of availableJobTypes; track $index) {
                  <option [value]="jType.id">
                    {{ jType?.name }}
                  </option>
                }
              </select>
            </div>
          </div>

          @for (day of weekDays; track day) {
            <div
              class="grid-cell grid-header-cell"
              [class.fw-bold]="currentDay == (day | date: 'yyyy-MM-dd')"
              [class.text-primary]="currentDay == (day | date: 'yyyy-MM-dd')"
              [class.bg-white]="currentDay == (day | date: 'yyyy-MM-dd')"
            >
              <div class="d-flex gap-1 mx-auto">
                <div class="">
                  {{ day | date: "EEEE" }}
                </div>
                <div class="">{{ day | date: "d MMM" }}</div>
              </div>
              <ng-template
                *ngTemplateOutlet="weatherTemplate; context: { date: day }"
              ></ng-template>
            </div>
          }

          @if (
            selectedClient?.id ||
            [6, 4].includes(selectedJobType?.type_identity)
          ) {
            @for (
              row of shiftDataGroupBy == "person"
                ? isAdminUser || isDispatcherUser
                  ? (userListData
                    | misc
                      : "getScheduleRowHeaders"
                      : !!filteredRosteredList?.length
                      : shiftDataGroupBy
                      : userListFilterId
                      : shiftFilterData?.selectedUsers
                      : "view")
                  : [currentUserData]
                : (siteListData
                  | misc
                    : "getScheduleRowHeaders"
                    : !!filteredRosteredList?.length
                    : shiftDataGroupBy
                    : userListFilterId
                    : shiftFilterData?.selectedSites
                    : "view");
              track row?.id
            ) {
              <div class="grid-cell grid-row-header">
                <div class="d-flex justify-content-between gap-2 mb-2">
                  <span>
                    <div [class.text-danger]="!row?.id">
                      @if (
                        selectedClient?.id == 1 &&
                        shiftDataGroupBy != "person" &&
                        row?.company?.company_name
                      ) {
                        {{ row?.company?.company_name }} -
                      }
                      {{
                        shiftDataGroupBy == "person"
                          ? row?.full_name
                          : row?.company_name
                      }}
                    </div>
                    @if (shiftDataGroupBy == "person") {
                      <div class="text-orange-700 fw-normal">
                        {{ row?.subcontractors }}
                      </div>
                    }
                  </span>
                  @if (shiftDataGroupBy == "person") {
                    @let hoursRostered =
                      shiftStatsBySite?.[row?.id]?.hours ||
                      shiftStatsByAssignee?.[row?.id]?.hours;

                    @if (hoursRostered) {
                      <div
                        class="d-flex align-items-center gap-1 mono-font"
                        id="hours-rostered"
                      >
                        {{ hoursRostered | misc: "getHoursFromMilliSeconds" }}
                      </div>
                    }
                  }
                </div>
                @if (
                  filteredRosteredList?.length &&
                  !isPastWeek &&
                  !selectedGlobalAction &&
                  (filteredRosteredList
                    | misc
                      : "checkItemsInRowExists"
                      : row
                      : (shiftDataGroupBy === "site"
                          ? "site_id"
                          : "assignee_id"))
                ) {
                  <div
                    class="d-flex justify-content-center"
                    (click)="copyShiftsToNextWeek(copyConfirmTemplate, row)"
                    [title]="
                      'Copy only ' +
                      (row?.full_name || row?.company_name) +
                      ' shifts'
                    "
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                  >
                    <span
                      role="button"
                      class="mx-auto p-0 px-2 border rounded bg-white text-secondary text-center small"
                    >
                      Copy Shifts
                    </span>
                  </div>
                }
              </div>

              <div
                class="grid-data-container"
                [class.slide-left-exit]="isCopyingWeek"
                [class.slide-left-enter]="isEnteringNewWeek"
              >
                @for (day of weekDays; track day) {
                  @if (row?.id == -1) {
                    <div class="grid-data-cell position-relative">
                      @let convertedDate = (day | date: "yyyy-MM-dd") || 0;
                      @let hoursRosteredByDate =
                        shiftStatsByDate?.[convertedDate]?.hours;

                      @if (hoursRosteredByDate) {
                        <div
                          class="d-flex align-items-center gap-1 mono-font justify-content-center"
                          id="hours-rostered-by-day"
                        >
                          {{
                            hoursRosteredByDate
                              | misc: "getHoursFromMilliSeconds"
                          }}
                        </div>
                      }
                    </div>
                  } @else {
                    @let cellKey = row?.id | misc: "getScheduleCellKey" : day;
                    <!-- @let cellKey = getScheduleCellKey(row.id, day) row?.id | misc:'getScheduleCellKey' :day; -->
                    @let colItems = rosterGridMap?.[cellKey] || [];
                    @let pastShift = day | misc: "isPastScheduleCheck";

                    @let isUserOnLeave = userLeaveData?.[cellKey];

                    <div
                      class="grid-data-cell position-relative"
                      cdkDropList
                      [cdkDropListData]="colItems"
                      (cdkDropListDropped)="onDrop($event, row, day)"
                      [cdkDropListEnterPredicate]="isFutureDayPredicate(day)"
                      [cdkDropListDisabled]="pastShift"
                      (click)="selectedGlobalAction = ''; selectedShift = null"
                    >
                      @if (isUserOnLeave?.length) {
                        <ng-template
                          *ngTemplateOutlet="
                            leaveInfoTemplate;
                            context: { isUserOnLeave }
                          "
                        ></ng-template>
                      }
                      @if (colItems.length) {
                        <div class="d-flex flex-column gap-1 mb-1">
                          @for (item of colItems; track item.id) {
                            @let conflictShift =
                              (conflictData
                                | misc: "rosterShiftDictEventDateData" : day)?.[
                                item?.assignee_id
                              ]?.jobs;

                            @let hasShiftStared =
                              item | misc: "hasShiftStarted";

                            <div
                              class="rostered-item text-dark small-font"
                              cdkDrag
                              [cdkDragDisabled]="
                                hasShiftStared ||
                                [2, 3].includes(item?.status_dict?.identity)
                              "
                              [cdkDragData]="item"
                              [ngClass]="
                                [2, 3].includes(item?.status_dict?.identity)
                                  ? 'border border-danger'
                                  : pastShift
                                    ? 'active-shift'
                                    : item?.draftedItem
                                      ? 'bg-warning-subtle'
                                      : !item?.assignee_id
                                        ? 'bg-danger-subtle'
                                        : 'active-shift'
                              "
                              [class.cursor-move]="
                                !hasShiftStared &&
                                ![2, 3].includes(item?.status_dict?.identity)
                              "
                              [class.is-selected]="
                                selectedShift?.id === item.id
                              "
                              [class.selected-global-action]="
                                selectedGlobalAction &&
                                selectedShift?.id === item.id
                              "
                              (click)="
                                onClickShift(item);
                                $event.stopImmediatePropagation()
                              "
                            >
                              <ng-template
                                *ngTemplateOutlet="
                                  shiftDetailTemplate;
                                  context: { item, conflictShift, day }
                                "
                              ></ng-template>

                              <div *cdkDragPlaceholder></div>
                              @if (
                                selectedShift?.id === item.id &&
                                !selectedGlobalAction &&
                                ![2, 3].includes(item?.status_dict?.identity)
                              ) {
                                <div class="d-flex gap-2 flex-row-reverse">
                                  @if (!pastShift) {
                                    <div
                                      (click)="
                                        onDeleteShift(selectedShift);
                                        $event.stopImmediatePropagation()
                                      "
                                    >
                                      <span class="del-button"></span>
                                    </div>
                                  }

                                  <div
                                    (click)="
                                      $event.stopImmediatePropagation();
                                      copySelectedShift(pastShift)
                                    "
                                    title="Copy"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                  >
                                    <i class="fs-6 fa-regular fa-copy"></i>
                                  </div>
                                  @if (!pastShift && !hasShiftStared) {
                                    <div
                                      (click)="
                                        selectedGlobalAction = 'move';
                                        $event.stopImmediatePropagation()
                                      "
                                      title="Cut"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                    >
                                      <i class="fs-6 fa-solid fa-scissors"></i>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                      <div class="d-flex justify-content-center m-auto gap-2">
                        @if (!pastShift) {
                          @if (
                            selectedShift &&
                            ["move", "copy"].includes(selectedGlobalAction)
                          ) {
                            <div
                              class="border rounded fw-semibold small bg-secondary-subtle text-dark w-100 text-center mb-1 px-2 py-1"
                              (click)="
                                onCellClick(row, day);
                                $event.stopImmediatePropagation()
                              "
                              role="button"
                            >
                              <i class="fa-regular fa-paste me-2"></i>Paste
                            </div>
                          } @else if (selectedGlobalAction == "add") {
                            <div
                              class="w-100 text-center px-5"
                              (click)="
                                selectedShift = null;
                                $event.stopImmediatePropagation();
                                onModifyShift(modifyShiftTemplate, row, day)
                              "
                              role="button"
                            >
                              <i
                                class="fa-solid fa-square-plus text-body-tertiary fs-5 d-none"
                              ></i>
                              <i
                                class="fa-solid fa-plus text-body-tertiary"
                              ></i>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            }
          }
        </div>
      </div>
    </div>
  } @else {
    <div
      class="scheduler-container"
      class="px-2"
      style="height: calc(100vh - 220px)"
    >
      @if (
        selectedClient?.id || [6, 4].includes(selectedJobType?.type_identity)
      ) {
        @for (
          row of shiftDataGroupBy == "person"
            ? [{ id: 0, full_name: "Unassigned" }].concat(userListData)
            : siteListData;
          track row?.id
        ) {
          @let day = selectedSearchDate;
          @let cellKey = getCellKey(row?.id, day);
          @let colItems = rosterGridMap?.[cellKey] || [];
          @let isUserOnLeave = userLeaveData?.[cellKey];

          @if (colItems.length || isUserOnLeave?.length) {
            @let pastShift = day | misc: "isPastScheduleCheck";

            <div
              class="d-flex justify-content-between gap-2 px-2 align-items-center gap-2 justify-content-between pt-2 fw-medium"
            >
              @if (selectedClient?.id == 1 && shiftDataGroupBy != "person") {
                {{ row?.company?.company_name }} -
              }
              {{
                shiftDataGroupBy == "person"
                  ? row?.full_name
                  : row?.company_name
              }}
              @if (shiftDataGroupBy == "person") {
                @if (shiftStatsByAssignee?.[row?.id]?.hours) {
                  <div class="d-flex align-items-center gap-1 mono-font">
                    {{
                      shiftStatsByAssignee?.[row?.id]?.hours
                        | misc: "getHoursFromMilliSeconds"
                    }}
                  </div>
                }
              }
            </div>
            @if (shiftDataGroupBy == "person") {
              <span class="text-orange-700 fw-normal px-2 small">
                {{ row?.subcontractors }}
              </span>
            }
            @if (isUserOnLeave?.length) {
              <ng-template
                *ngTemplateOutlet="
                  leaveInfoTemplate;
                  context: { isUserOnLeave }
                "
              ></ng-template>
            }
            <div class="d-flex flex-column gap-2 mb-1">
              @for (item of colItems; track item.id) {
                @let conflictShift =
                  (conflictData | misc: "rosterShiftDictEventDateData" : day)?.[
                    item?.assignee_id
                  ]?.jobs;

                <div
                  role="button"
                  class="rostered-item text-dark small-font cursor-pointer w-100"
                  [ngClass]="
                    pastShift
                      ? 'active-shift'
                      : item?.draftedItem
                        ? 'bg-warning-subtle opacity-75'
                        : !item?.assignee_id
                          ? 'bg-danger-subtle'
                          : 'active-shift'
                  "
                  [class.is-selected]="selectedShift?.id === item.id"
                  (click)="onClickShift(item)"
                >
                  <ng-template
                    *ngTemplateOutlet="
                      shiftDetailTemplate;
                      context: { item, conflictShift, day }
                    "
                  ></ng-template>
                </div>
              }
            </div>
          }
        }
      }
    </div>
  }
}

<ng-template
  #modifyShiftTemplate
  let-data
  let-modifyShiftTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="grid-cell grid-header-cell">
      <div
        class="d-flex gap-2 align-items-center justify-content-around w-100 flex-wrap"
      >
        <div class="d-flex gap-1 align-items-center fs-6">
          <div>
            {{ data?.shift?.event_date | date: "EEEE" }}
          </div>

          <div>
            {{ data?.shift?.event_date | date: "d MMM" }}
          </div>

          @if (
            currentDay == (data?.shift?.event_date | date: "yyyy-MM-dd") &&
            largeView
          ) {
            <div>[TODAY]</div>
          }
        </div>
        <div class="fw-bold">
          {{ selectedJobType?.name }}
        </div>

        <ng-template
          *ngTemplateOutlet="
            weatherTemplate;
            context: { date: data?.shift?.event_date }
          "
        ></ng-template>
      </div>
    </div>
    <div class="p-3 text-dark my-2 ps-0">
      @if (selectedClient?.id) {
        <dl class="ps-3">
          @if (data?.shift?.site_id) {
            <dt>Site</dt>
          }
          <dd>
            @if (data?.shift?.site_id) {
              <div class="d-flex gap-1 align-items-center mb-4">
                <!-- <i class="fa-solid fa-location"></i> -->
                <span>
                  {{ data?.shift?.site_name }}
                </span>
                <span
                  class="edit-button ms-2"
                  (click)="editShiftInfo(data, 'site')"
                ></span>
              </div>
            } @else {
              <gtapp-auto-complete
                [data]="siteLookupListData"
                placeHolder="Site"
                searchKeyword="company_name"
                [itemTemplate]="siteLookupTemplate"
                inputId="siteLookupFieldId"
                (inputChanged)="onSiteLookup($event)"
                (selected)="onSiteSelect(data, $event)"
              >
              </gtapp-auto-complete>
              <ng-template #siteLookupTemplate let-item>
                <div>
                  {{ item?.company_name }}
                  @if (selectedClient?.id == 1) {
                    [{{ item?.company?.company_name }}]
                  }
                </div>
                <div class="small-font text-secondary">
                  {{ item?.address?.full_address || item?.full_address }}
                </div>
              </ng-template>
            }
          </dd>
        </dl>

        @if (selectedJobType?.type_identity === 2) {
          <dl class="p-3">
            <!--https://app.shortcut.com/sendem/story/13913/add-positions-to-static-shifts -->
            <!--https://app.shortcut.com/sendem/story/13916/add-job-number-for-static-guards-shifts-->
            <div class="row row-cols-1 row-cols-lg-2">
              <div class="col">
                <div class="input-group">
                  <div class="form-floating">
                    <input
                      class="form-control"
                      id="jobNumberField"
                      type="text"
                      placeholder=""
                      [(ngModel)]="data.shift.external_job_id"
                      autocomplete="off"
                      oninput="this.value = this.value.toUpperCase()"
                    />
                    <label>Job Number (Optional)</label>
                  </div>
                  @if (data?.shift?.external_job_id) {
                    <span
                      class="input-group-text"
                      (click)="
                        data.shift.external_job_id = '';
                        shiftFocus('externalJobIdField')
                      "
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
              </div>
              <div class="col">
                <div class="input-group">
                  <div class="form-floating">
                    <input
                      class="form-control"
                      id="positionField"
                      placeholder=""
                      type="text"
                      [(ngModel)]="data.shift.position"
                      autocomplete="off"
                    />
                    <label>Position (Optional)</label>
                  </div>
                  @if (data?.shift?.position) {
                    <span
                      class="input-group-text"
                      (click)="
                        data.shift.position = '';
                        shiftFocus('externalJobIdField')
                      "
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
              </div>
            </div>
          </dl>
        }
      } @else {
        <dl [ngClass]="data?.shift?.name ? 'ps-2' : 'ps-3'">
          <gtapp-input-field
            dtValue="Patrol Name"
            inputId="name"
            [maxLength]="500"
            [inputStringValue]="data?.shift?.name"
            (blurEmit)="data.shift.name = $event"
          >
          </gtapp-input-field>
        </dl>
      }

      <div class="mb-3">
        <gtapp-scheduler
          [dialogBox]="false"
          [schedulerForm]="data?.schedulerForm"
          [editSchedule]="true"
          shownFrom="schedule"
        ></gtapp-scheduler>
      </div>
      <dl class="ps-3">
        @if (data?.shift?.assignee_id) {
          <dt>Assignee</dt>
        }
        <dd>
          @if (data?.shift?.assignee_id) {
            <div class="d-flex gap-1 align-items-center mb-4">
              <span>
                {{ data?.shift?.assignee_name }}
              </span>
              <span
                class="edit-button ms-2"
                (click)="editShiftInfo(data, 'assignee')"
              ></span>
            </div>
          } @else {
            <gtapp-auto-complete
              [data]="userLookupListData"
              placeHolder="Assignee"
              searchKeyword="full_name"
              [itemTemplate]="userTemplate"
              inputId="userLookupFieldId"
              (inputChanged)="onUserLookup($event)"
              (selected)="onUserSelect(data, $event)"
            >
            </gtapp-auto-complete>
            <ng-template #userTemplate let-item>
              <div
                class="d-flex gap-2 flex-wrap justify-content-between align-items-start"
              >
                <div class="d-flex gap-2 flex-wrap align-items-start">
                  <span>
                    {{ item?.full_name }}
                  </span>
                  @if (item?.access_status === 2) {
                    <div
                      class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                    >
                      Casual
                    </div>
                  }
                  <!-- @if (
                    selectedSiteExtraDetails?.preferred_user_ids?.includes(
                      item?.id
                    )
                  ) {
                    <div
                      class="text-success-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                    >
                      Preferred
                    </div>
                  } -->
                </div>
                <div class="text-secondary small-font">
                  @if (shiftStatsByAssignee?.[item?.id]?.hours) {
                    <div>
                      Hours:
                      {{
                        shiftStatsByAssignee?.[item?.id]?.hours
                          | misc: "getHoursFromMilliSeconds"
                      }}
                    </div>
                  }
                  @if (shiftStatsByAssignee?.[item?.id]?.shifts) {
                    <div>
                      Shifts: {{ shiftStatsByAssignee?.[item?.id]?.shifts }}
                    </div>
                  }
                </div>
              </div>

              @if (item?.subcontractors?.length) {
                <div class="small text-secondary">
                  🟧Subcontractor:
                  <span class="subcontractor-name">{{
                    item?.subcontractors
                  }}</span>
                </div>
              }
            </ng-template>
          }
        </dd>
      </dl>
    </div>

    <div class="d-flex gap-2">
      <button
        class="btn btn-secondary w-100 btn-lg"
        (click)="modifyShiftTemplateRef.close(false)"
      >
        Cancel
      </button>
      <button
        class="btn btn-success w-100 btn-lg"
        [disabled]="
          selectedClient?.id ? !data?.shift?.site_id : !data?.shift?.name
        "
        (click)="modifyShiftTemplateRef.close(data)"
      >
        {{ selectedClient?.id || data?.editingShift ? "Save" : "Add Details" }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #weatherTemplate let-date="date">
  @if ((weatherData | misc: "getWeatherFromDate" : date)?.Condition?.text) {
    <div
      class="p-0 text-center cursor-pointer weather-section"
      (click)="openWeatherTemplate(weatherInfoTemplate, weatherData, date)"
    >
      @if (
        (weatherData | misc: "getWeatherFromDate" : date)?.Condition?.icon_id
      ) {
        <img
          width="18"
          height="18"
          class="me-1"
          src="https://raw.githubusercontent.com/visualcrossing/WeatherIcons/58c79610addf3d4d91471abbb95b05e96fb43019/SVG/4th%20Set%20-%20Color/{{
            (weatherData | misc: 'getWeatherFromDate' : date)?.Condition
              ?.icon_id
          }}.svg"
        />
      }
      {{ (weatherData | misc: "getWeatherFromDate" : date)?.Condition?.text }}
    </div>
  }
</ng-template>

<ng-template #weatherInfoTemplate let-weatherInfoTemplate="dialogRef" let-data>
  <div class="dialog-box card">
    <div class="card-header">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1">
          @if (weatherAddressInfo?.city_name) {
            <div class="fw-semibold">
              {{ weatherAddressInfo?.city_name
              }}{{
                weatherAddressInfo?.state_code
                  ? ", " + weatherAddressInfo?.state_code
                  : ""
              }}
            </div>
          }

          <div>
            {{ data?.selectedDate | customDate: "EEEE d MMM yyyy" }}
          </div>
        </div>
        <div>
          <span (click)="weatherInfoTemplate.close()">
            <i class="fa-solid fa-xmark"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mb-4">
      <div>
        {{ data?.weatherData?.["Description"] }}
      </div>
      @if (data?.weatherData?.["Condition"]?.icon_id) {
        <div>
          <img
            width="40"
            height="40"
            class="ms-3"
            src="https://raw.githubusercontent.com/visualcrossing/WeatherIcons/58c79610addf3d4d91471abbb95b05e96fb43019/SVG/4th%20Set%20-%20Color/{{
              data?.weatherData?.['Condition']?.icon_id
            }}.svg"
          />
        </div>
      }
    </div>

    <div class="row row-cols-3">
      @for (item of data?.weatherKeys; track item) {
        <dl>
          <dt>{{ item }}</dt>
          <dd>
            {{ data?.weatherData?.[item] }}
          </dd>
        </dl>
      }
    </div>
    <div class="small text-end text-secondary">
      Weather provided by www.visualcrossing.com
    </div>
  </div>
</ng-template>

<ng-template
  #sendShiftNotificationTemplate
  let-data
  let-sendShiftNotificationTemplate="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      Publish Shifts
      <span class="float-end" (click)="sendShiftNotificationTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="mb-2">
      Send an email to notify the following they have allocated shifts to
      accept.
    </div>
    @for (assignee of data; track assignee) {
      <ul class="mb-0">
        <li>
          {{ assignee?.assignee_name }}
        </li>
      </ul>
    }
    @if (data?.length) {
      <div class="pt-3">
        Recipients:
        <span class="fs-6">{{ data?.length }}</span>
      </div>
    }

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="sendShiftNotificationTemplate.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-success btn-lg w-100"
          [disabled]="!data?.length"
          (click)="sendShiftNotificationTemplate.close(true)"
        >
          Send Notification
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template
  #copyConfirmTemplate
  let-data
  let-copyConfirmTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      Copy Shifts
      <span class="float-end" (click)="copyConfirmTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group ms-2 mb-5">
        <!-- Radio Group Label, if needed -->
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="radio"
            id="shiftAssigneeKeepCheck1"
            [value]="0"
            [(ngModel)]="data.removeAssigneeWhileCopying"
            [checked]="data?.removeAssigneeWhileCopying === 0"
          />
          <label class="form-check-label" for="shiftAssigneeKeepCheck1">
            Keep assignee in shifts
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="shiftAssigneeKeepCheck2"
            [value]="1"
            [(ngModel)]="data.removeAssigneeWhileCopying"
            [checked]="data?.removeAssigneeWhileCopying === 1"
            autocomplete="off"
          />
          <label class="form-check-label" for="shiftAssigneeKeepCheck2">
            Remove assignee from shifts
          </label>
        </div>
      </div>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="copyConfirmTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-success btn-lg w-100"
          (click)="copyConfirmTemplateRef.close(data)"
        >
          Copy
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #shiftDetailTemplate
  let-item="item"
  let-conflictShift="conflictShift"
  let-eventDay="day"
>
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-start">
      <span class=""> {{ item?.start_time }} - {{ item?.end_time }} </span>
      @if (conflictShift && selectedGlobalAction != "print") {
        <span
          class="text-danger ms-2"
          title="Conflict Detected"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
        >
          <i class="fa-solid fa-business-time"></i>
        </span>
      }
    </div>
    @if (selectedGlobalAction != "print") {
      @if ([2, 3].includes(item?.status_dict?.identity)) {
        <span
          title="Shift Cancelled"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          class="text-success fw-bold"
          ><i class="fa-solid fa-ban text-danger"></i
        ></span>
      } @else {
        @if (
          ![6].includes(selectedJobType?.type_identity) && !item?.draftedItem
        ) {
          <div>
            @if (item?.acceptance_status == 1) {
              <span
                title="Shift Accepted"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                class="text-success fw-bold"
                ><i class="fa-solid fa-circle-check"></i
              ></span>
            }
            @if (item?.acceptance_status == 2) {
              <span
                title="Pending Acceptance"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                class="text-warning fw-bold"
                ><i class="fa-solid fa-circle-question"></i
              ></span>
            }
          </div>
        }
      }
    }
  </div>
  @if (
    jobShiftOnsiteOffsiteInfo?.[item?.id]?.onsite_time &&
    jobShiftOnsiteOffsiteInfo?.[item?.id]?.offsite_time
  ) {
    @let onsiteTime = jobShiftOnsiteOffsiteInfo?.[item?.id]?.onsite_time;
    @let offsiteTime = jobShiftOnsiteOffsiteInfo?.[item?.id]?.offsite_time;

    <span class="text-success fw-medium">
      @if ((onsiteTime | date: "d MMM y") == (eventDay | date: "d MMM y")) {
        {{ onsiteTime | date: "HH:mm" }}
      } @else {
        {{ onsiteTime | customDate: "d MMM y HH:mm" }}
      }
    </span>
    <span class="text-success fw-medium">
      @if ((offsiteTime | date: "d MMM y") == (eventDay | date: "d MMM y")) {
        - {{ offsiteTime | date: "HH:mm" }}
      } @else {
        - {{ offsiteTime | customDate: "d MMM y HH:mm" }}
      }
    </span>
    <span class="text-success fw-medium">
      [{{
        jobShiftOnsiteOffsiteInfo?.[item?.id]?.duration * 1000
          | misc: "getHoursFromMilliSeconds"
      }}]
    </span>
  }

  <div class="fw-medium text-break d-flex gap-1">
    <div class="flex-grow-1">
      @switch (selectedJobType?.type_identity) {
        @case (6) {
          {{ item?.name }}
        }
        @case (4) {
          {{ item?.name }}
        }
        @default {
          @if (shiftDataGroupBy == "person") {
            {{ item?.site_name }}
          } @else if (item?.assignee_id) {
            <div>
              <div>
                {{ item?.assignee_name }}
              </div>

              @if (subContractorAssigneeMap.has(item?.assignee_id)) {
                <div class="text-orange-700 fw-normal">
                  {{ subContractorAssigneeMap.get(item?.assignee_id) }}
                </div>
              }
            </div>
          }
        }
      }
    </div>
    @if (item?.interval_check && item?.assignee_id) {
      <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        [title]="`Welfare check every ${item?.interval_check} mins.`"
      >
        <i class="fa-solid fa-person-circle-check fs-6"></i>
      </span>
    }
  </div>
  @if (item?.position) {
    <div>
      {{ item?.position }}
    </div>
  }
</ng-template>

<ng-template #leaveInfoTemplate let-isUserOnLeave="isUserOnLeave">
  <div class="d-flex flex-column gap-1 mb-1">
    @for (leaveInfo of isUserOnLeave; track $index) {
      <div
        class="d-flex gap-2 small-font border border-danger bg-secondary-subtle p-2 py-3 rounded text-danger justify-content-between"
      >
        <span>
          {{
            leaveInfo?.leave_session == 0
              ? "Full Day"
              : leaveInfo?.leave_session == 1
                ? "Forenoon"
                : "Afternoon"
          }}
          Leave
        </span>
        <div class="d-flex gap-2">
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            [title]="leaveInfo?.leave_reason"
          >
            <i class="fa-solid fa-circle-info text-info"></i>
          </span>
          @if (leaveInfo?.leave_status == 1) {
            <span
              title="Leave Accepted"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              class="text-success fw-bold"
              ><i class="fa-solid fa-circle-check"></i
            ></span>
          }
          @if (leaveInfo?.leave_status == 0) {
            <span
              title="Pending Acceptance"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              class="text-warning fw-bold"
              ><i class="fa-solid fa-circle-question"></i
            ></span>
          }
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #filterShiftsTemplate let-filterShiftsTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">Filter Data</div>
    <div class="row row-cols-2 mb-3">
      <div class="col">
        @if (
          shiftFilterData?.selectedUsers?.length ||
          shiftFilterData?.selectedSites?.length
        ) {
          <button
            type="button"
            class="btn btn-outline-danger btn-md w-100"
            (click)="
              shiftFilterData = { selectedUsers: [], selectedSites: [] };
              filterShiftsTemplateRef.close(true)
            "
          >
            Clear Filters
          </button>
        } @else {
          <button
            type="button"
            class="btn btn-dark btn-md w-100"
            (click)="filterShiftsTemplateRef.close(false)"
          >
            Close
          </button>
        }
      </div>
      <div class="col">
        <button
          class="btn btn-success btn-md w-100"
          (click)="filterShiftsTemplateRef.close(true)"
        >
          Apply Filter
        </button>
      </div>
    </div>
    <div class="row row-cols-2">
      @if (![4, 6].includes(selectedJobType?.type_identity)) {
        <div class="col">
          <dt>Site(s)</dt>
          <div class="d-flex flex-column gap-2 small-font mb-2 pe-4">
            @for (item of shiftFilterData?.selectedSites; track $index) {
              <div
                class="d-flex gap-2 bg-secondary-subtle text-dark rounded p-2"
              >
                <div class="flex-grow-1">
                  {{ item?.company_name }}
                </div>

                <span
                  (click)="shiftFilterData?.selectedSites?.splice($index, 1)"
                >
                  <i class="fa-solid fa-minus-circle text-danger"></i>
                </span>
              </div>
            }
          </div>
          <gtapp-auto-complete
            [data]="siteLookupListData"
            placeHolder="Site"
            searchKeyword="company_name"
            [itemTemplate]="shiftFilterSiteLookupTemplate"
            inputId="shiftFilterSiteLookupFieldId"
            (inputChanged)="onSiteLookup($event)"
            (selected)="onShiftFilterSelect($event)"
          >
          </gtapp-auto-complete>
          <ng-template #shiftFilterSiteLookupTemplate let-item>
            <div>
              {{ item?.company_name }}
              @if (selectedClient?.id == 1) {
                [{{ item?.company?.company_name }}]
              }
            </div>
            <div class="small-font text-secondary">
              {{ item?.address?.full_address || item?.full_address }}
            </div>
          </ng-template>
        </div>
      }
      <div class="col">
        <dt>Staff</dt>
        <div class="d-flex flex-column gap-2 small-font mb-2 pe-4">
          @for (item of shiftFilterData?.selectedUsers; track $index) {
            <div class="d-flex gap-2 bg-secondary-subtle text-dark rounded p-2">
              <div class="flex-grow-1">
                {{ item?.full_name }}
              </div>

              <span (click)="shiftFilterData?.selectedUsers?.splice($index, 1)">
                <i class="fa-solid fa-minus-circle text-danger"></i>
              </span>
            </div>
          }
        </div>
        <gtapp-auto-complete
          [data]="userLookupListData"
          placeHolder="Assignee"
          searchKeyword="full_name"
          [itemTemplate]="shiftFilterUserTemplate"
          inputId="shiftFilterUserLookupFieldId"
          (inputChanged)="onUserLookup($event)"
          (selected)="onShiftFilterSelect($event, 'person')"
        >
        </gtapp-auto-complete>
        <ng-template #shiftFilterUserTemplate let-item>
          <div
            class="d-flex gap-2 flex-wrap justify-content-between align-items-start"
          >
            <div class="d-flex gap-2 flex-wrap align-items-start">
              <span>
                {{ item?.full_name }}
              </span>
              @if (item?.access_status === 2) {
                <div
                  class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                >
                  Casual
                </div>
              }
            </div>
            <div class="text-secondary small-font">
              @if (shiftStatsByAssignee?.[item?.id]?.hours) {
                <div>
                  Hours:
                  {{
                    shiftStatsByAssignee?.[item?.id]?.hours
                      | misc: "getHoursFromMilliSeconds"
                  }}
                </div>
              }
              @if (shiftStatsByAssignee?.[item?.id]?.shifts) {
                <div>
                  Shifts: {{ shiftStatsByAssignee?.[item?.id]?.shifts }}
                </div>
              }
            </div>
          </div>

          @if (item?.subcontractors?.length) {
            <div class="small text-secondary">
              🟧Subcontractor:
              <span class="subcontractor-name">{{ item?.subcontractors }}</span>
            </div>
          }
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
